// the query param is required to match Cloudflare’s proxy query param mapping
// https://github.com/ratehub/cloudflare-workers/blob/main/ratehub-ca/src/proxySettings.js
export default {
    email: 'email',
    firstName: 'first_name',
    lastName: 'last_name',
    isGiftCardLead: 'is_gift_card_lead',
};
